const MIN_SIGNAL_RECORD_MS = 700;
const MIN_AUDIO_PEAK = 0.001;

export function maxAudioPeak(input: Float32Array): number {
  let peak = 0;
  for (const sample of input) {
    peak = Math.max(peak, Math.abs(sample));
  }
  return peak;
}

export function isSilentCapture(maxPeak: number, durationMs: number): boolean {
  return durationMs >= MIN_SIGNAL_RECORD_MS && maxPeak < MIN_AUDIO_PEAK;
}
